import React, { useMemo } from 'react';
import { getIntl } from '../../../utils/intl';
import FullScreenImageView from '../../v2BaseComponents/FullScreenImageView/FullScreenImageView';
import LargeDescriptiveImage from '../../v2BaseComponents/LargeDescriptiveImage';
import { CareTeamMemberSource, getCareTeamMemberInsuranceCardAvatarUrl } from '../../../utils/careTeamUtils';
import { AvatarAPIImagesProvider } from '../../v2BaseComponents/FullScreenImageView';
import { AvatarAPIViewerImage } from '../../v2BaseComponents/FullScreenImageView/AvatarAPIImagesProvider';

const intl = getIntl('InsuranceCards', {
    front: 'Insurance Card Front',
    back: 'Insurance Card Back',
});

export type InsuranceCardsOwnProps = {
    careTeamMemberId: string;
    source: CareTeamMemberSource;
};

export type InsuranceCardsProps = InsuranceCardsOwnProps;

type ImageEntryWithSide = AvatarAPIViewerImage<{ side: 'front' | 'back' }>;

const InsuranceCards: React.FC<InsuranceCardsProps> = ({ careTeamMemberId, source }) => {
    const frontImage = getCareTeamMemberInsuranceCardAvatarUrl(source, careTeamMemberId, 'front');
    const backImage = getCareTeamMemberInsuranceCardAvatarUrl(source, careTeamMemberId, 'back');
    const imageEntries: ImageEntryWithSide[] = useMemo(
        () =>
            [
                {
                    imageViewImageUrl: frontImage,
                    imageViewImageDescription: intl('front'),
                    side: 'front',
                },
                {
                    imageViewImageUrl: backImage,
                    imageViewImageDescription: intl('back'),
                    side: 'back',
                },
            ]
                .filter((image) => !!image.imageViewImageUrl)
                .map((image) => image as ImageEntryWithSide),
        [frontImage, backImage],
    );

    return (
        <AvatarAPIImagesProvider images={imageEntries}>
            {(renderImagesData) => (
                <FullScreenImageView
                    renderImagesData={renderImagesData}
                    renderImages={(images, onPress, getIsPressEnabled) =>
                        images.map((image) => (
                            <LargeDescriptiveImage
                                key={image.side}
                                imageUrl={image.imageViewImageUrl}
                                description={image.imageViewImageDescription}
                                onPress={getIsPressEnabled(image) ? () => onPress(image) : undefined}
                            />
                        ))
                    }
                />
            )}
        </AvatarAPIImagesProvider>
    );
};

export default React.memo(InsuranceCards);
